<template>
  <div class="jijiagong-page">
    <div class="haeder-container blackStatic">
      <Header></Header>
      <Nav></Nav>
    </div>
    <div class="banner jijiagong_banner">
			<div class="bodyinfo">
				<h2>机加工互联</h2>
				<p>以数据驱动车间智能化变革让生产更加轻松</p>
				<!-- <a href="javascript:;" class="case-see-more-btn">查看更多</a> -->
			</div>
		</div>
    <div class="jijiagong_body">
      <div class="jijiagong1">
        <span class="span1">APPLICATION</span>
        <span class="span2">机加工互联</span>
        <img class="img1" src="../../html/image/jijiagong/4.png">
        <span class="span3">生产产量进度</span>
      </div>
      <div class="jijiagong2">
        <span class="span1">车间详情</span>
        <span class="span2">机床状态、运行详情</span>
        <img class="img1" src="../../html/image/jijiagong/6.png">
        <img class="img2" src="../../html/image/jijiagong/1.png">
        <div class="jijiagong2_box">
          
        </div>
      </div>
      <div class="jijiagong3">
        <span class="span1">数据统计</span>
        <span class="span2">设备利用率、故障统计</span>
        <img class="img1" src="../../html/image/jijiagong/5.png">
        <img class="img2" src="../../html/image/jijiagong/jijiagong_img3_2.png">
        <div class="jijiagong3_box">
        </div>
      </div>
    </div>
    <Foot></Foot>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Nav from '@/components/Nav'
import Foot from '@/components/Foot'

export default {
  name: 'jijiagong',
  components:{
    Header,
    Nav,
    Foot
  },
  data(){
    return {

    }
  },
  mounted() {
  },
}
</script>
<style  scoped>
  @import '../../html/css/zkm.css';
  @import '../../html/css/zkm.market.css';
</style>
